<section class="ei-popup">
    <form class="ei-popup-form">
        <div class="row">
            <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3" *ngIf="roleDropdownList">
                <label>Role</label>
                <mat-form-field appearance="outline" class="custom-dropdown">
                    <input style="border:none;width:100%" class="edit text-notavailable-option option-size" />
                    <mat-select placeholder='Select Role' name="role" [(ngModel)]="role"
                        (selectionChange)="roleSelected(role)">
                        <mat-option class="roleDropdownList" *ngFor="let role of roleDropdownList" [value]="role">
                            <ng-container>{{role}}</ng-container>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
                <label style="margin-bottom: 0.4rem;">Names</label>
                <mat-form-field class="inline-form-edit chip-select-stakeholder select-user-dropdown" floatLabel="never">
                    <mat-chip-grid #chipList>
                        <mat-chip-row class="stk-mat-chip" *ngIf="selectedUsers && selectedUsers.givenName"
                            (removed)="remove()">
                            {{selectedUsers.givenName}} {{selectedUsers.sn}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input placeholder="Search by Name/Email" [matAutocomplete]="auto" (keyup)="keyUpSearch($event)"
                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                    <mat-autocomplete showPanel=true class="lob-options-list" #auto="matAutocomplete"
                        (optionSelected)="selected($event)">

                        <mat-option [disabled]="checkexist(user)" *ngFor="let user of users"
                            title="{{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})" [value]="user">
                            {{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 multi-dropdown">
                <label>Segment/LOB/SubLOB</label>
                <div *ngIf="lobdropdwnDataSource">
                    <app-multiselect-group-checkbox [dropdowndataSource]="lobdropdwnDataSource"
                        [hierarchyDropdownConfig]="hierarchyDropdownConfig" [selectValues]="selectValues"
                        [disableMultiSelect]="disableMultiSelect"
                        (selectedHierarchy)="selectedHierarchy($event)" [placeholderText]="'Select Segment/LOB/SubLOB'"></app-multiselect-group-checkbox>
                </div>
            </div>
        </div>
    </form>
    <div class="pull-right subLob-edit-apply me-3">
        <button mat-mdc-raised-button [disabled]="disableSubmit()" (click)="submitForm()"
            class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
            Submit
        </button>
    </div>
</section>